import client from '../../base-api';

const serviceURL = '/course-private-coaching';

const coursePrivateCoachingService = {

    getCourses(filterData: any) {
        return client.get(`${serviceURL}`, {params: filterData});
    },
    getCourse(courseId: number) {
        return client.get(`${serviceURL}/${courseId}`);
    },
    postCourse(courseData: any) {
        return client.post(`${serviceURL}`, courseData);
    },
    putCourse(courseData: any, courseId: number) {
        return client.put(`${serviceURL}/${courseId}`, courseData);
    },
    deleteCourse(courseId: number) {
        return client.delete(`${serviceURL}/delete/${courseId}`);
    },


    // BBQ
    bbqPostCourse(courseData: any) {
        return client.post(`${serviceURL}/bbq`, courseData);
    },
    bbqPutCourse(courseData: any, courseId: number) {
        return client.put(`${serviceURL}/bbq/${courseId}`, courseData);
    },
}

export default coursePrivateCoachingService;